





































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, namespace, State } from 'vuex-class';
import { ToastProgrammatic as Toast } from 'buefy';
import { isTruthy } from '../../../jbi-shared/util/watcher.vue-decorator';
import InteractiveModal from '@/components/base/InteractiveModal.vue';
import {
  JBICriteriaStatus,
  ProjectCriteriaAcknowledgement,
  ProjectDetailPayload,
  UpdatedJBICriteriaResponse,
  UpdateJBICriteriaAcknowledgmentPayload,
} from '../../../store/modules/projects/types/projects.types';
import { ApiState } from '../../../store/types/general.types';
import { RootState } from '../../../store/store';
import { AxiosError } from 'axios';
import { CRITERION_TYPE } from '../../../store/types/criterions.types';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    InteractiveModal,
  },
})
export default class JBICriteriaAcknowledgmentModal extends Vue {
  @Prop() public projectId!: number;
  @Prop() public updatedJBICriteriaResponse!: UpdatedJBICriteriaResponse;
  @Prop()
  public projectCriteriaAcknowledgement!: ProjectCriteriaAcknowledgement;

  @Prop({ type: Boolean, required: true })
  public isModalActive!: boolean;

  @Prop({ type: Boolean, required: true })
  public isMinimized!: boolean;

  @Action('projects/updateJBICriteriaAcknowledgment')
  public updateJBICriteriaAcknowledgment!: (
    payload: UpdateJBICriteriaAcknowledgmentPayload,
  ) => void;

  @Action('projects/getUpdatedJBICriteriaWithAcknowledgement')
  public getUpdatedJBICriteriaWithAcknowledgement!: (projectId: number) => void;

  @State(
    (state: RootState) =>
      state.projects.apiState.getUpdateJBICriteriaAcknowledgment,
  )
  public getUpdateJBICriteriaAcknowledgmentState!: ApiState;

  @State((state) => state.projects.projectDetail)
  public projectDetail!: ProjectDetailPayload;

  public async handleClose(): Promise<void> {
    const modal = this.$refs.interactiveModalRef as InteractiveModal;
    if (modal) {
      modal.handleAttemptClose();
    }
  }

  get criteriaType(): typeof CRITERION_TYPE {
    return CRITERION_TYPE;
  }

  get jbiCriteriaStatus(): typeof JBICriteriaStatus {
    return JBICriteriaStatus;
  }

  get JBICriteriaUpdates() {
    return [
      {
        status: JBICriteriaStatus.UPDATED,
        criteriaList: this.updatedJBICriteriaResponse.updatedJBICriteria,
      },
      {
        status: JBICriteriaStatus.NEW,
        criteriaList: this.updatedJBICriteriaResponse.newJBICriteria,
      },
      {
        status: JBICriteriaStatus.DELETED,
        criteriaList: this.updatedJBICriteriaResponse.deletedJBICriteria,
      },
    ];
  }

  public acknowledgeJBICriteriaChanges(): void {
    const payload: UpdateJBICriteriaAcknowledgmentPayload = {
      projectId: this.projectId,
      projectCriteriaAcknowledgement: this.projectCriteriaAcknowledgement,
    };
    this.updateJBICriteriaAcknowledgment(payload);
  }

  @Watch('getUpdateJBICriteriaAcknowledgmentState.success')
  @isTruthy
  public watchGetUpdateJBICriteriaAcknowledgmentStateSuccess(): void {
    Toast.open({
      message: 'Successfully Acknowledged.',
      position: 'is-top',
      type: 'is-dark',
      duration: 3500,
    });
    this.$emit('close');
    this.getUpdatedJBICriteriaWithAcknowledgement(this.projectId);
  }

  @Watch('getUpdateJBICriteriaAcknowledgmentState.error')
  @isTruthy
  public watchGetUpdateJBICriteriaAcknowledgmentStateError(
    error: AxiosError,
  ): void {
    Toast.open({
      message:
        error && error.response && error.response.data
          ? error.response.data.message
          : 'Something went wrong. Please try again.',
      position: 'is-top',
      type: 'is-danger',
      duration: 3500,
    });
    this.$emit('close');
  }

  /**
   * Computed property for modal content to prevent Vue prop mutation warnings.
   * Creates an intermediary between static text and InteractiveModal prop.
   */
  get jbiCriteriaUpdatesText(): string {
    return 'JBI Criteria Updates';
  }
}
